import { MutationOptions, useMutation } from "react-query";
import { APIError, APIResponse, API_URL_V1, post } from "../api";

export interface VerifyBusinessPayload {
  rcNumber: string;
  type: string;
}

function useVerifyBusiness(
  options?: MutationOptions<APIResponse<any>, APIError, VerifyBusinessPayload>
) {
  const { isLoading, mutate, error, data, reset } = useMutation<
    APIResponse<any>,
    APIError,
    VerifyBusinessPayload
  >(
    async (variables) => {
      return post(
        `${API_URL_V1}/kyb/cac/advanced`,
        variables,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
    },
    { ...options }
  );

  return {
    verifyBusiness: mutate,
    isVerifyingBusiness: isLoading,
    verifyBusinessError: error,
    verificationData: data,
    resetVerification: reset,
  };
}

export default useVerifyBusiness;